/* Pagina Sobre: efeitos de scroll (revelar texto/imagens e faixa de texto). Conteudo continua no HTML; sem JS ou com reduced-motion nada fica escondido. */
(function () {
  if (window.__lpsReveal) return;
  window.__lpsReveal = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function splitWords(el) {
    if (el.getAttribute('data-lps-done')) return;
    el.setAttribute('data-lps-done', '1');
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return;
    el.setAttribute('aria-label', text);
    el.innerHTML = text.split(' ').map(function (w, i) {
      var span = document.createElement('span');
      span.textContent = w;
      return '<span class="lps-w" aria-hidden="true"><span style="--i:' + i + '">' + span.innerHTML + '</span></span>';
    }).join(' ');
  }

  function initReveal() {
    document.documentElement.classList.add('lps-anim');
    var words = document.querySelectorAll('[data-lps-words]');
    for (var i = 0; i < words.length; i++) splitWords(words[i]);
    var els = document.querySelectorAll('[data-lps-reveal],[data-lps-words]');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    for (var j = 0; j < els.length; j++) io.observe(els[j]);
  }

  function initBands() {
    var bands = Array.prototype.slice.call(document.querySelectorAll('[data-lps-marquee]'));
    if (!bands.length) return;
    var ticking = false;
    function update() {
      var vh = window.innerHeight;
      bands.forEach(function (b) {
        var r = b.parentElement.getBoundingClientRect();
        if (r.bottom < 0 || r.top > vh) return;
        var p = (vh - r.top) / (vh + r.height);
        var max = Math.max(0, b.scrollWidth - b.parentElement.clientWidth);
        var x = b.getAttribute('data-lps-marquee') === 'right' ? -(1 - p) * max : -p * max;
        b.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    if (reduce || !('IntersectionObserver' in window)) return;
    initReveal();
    initBands();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
